import React from "react";
import { Flask, CircleNotch } from "@phosphor-icons/react";

export default function SaveExperimentDialog({ dialog, saving, onChangeTitle, onCancel, onConfirm }) {
  if (!dialog) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/60 backdrop-blur-xl flex items-center justify-center p-5" onClick={onCancel}>
      <div
        data-testid="save-experiment-dialog"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-bg border border-white/10 rounded-2xl p-5"
      >
        <div className="flex items-center gap-2 text-volt mb-3">
          <Flask size={22} weight="duotone" />
          <h3 className="font-heading text-lg font-bold">EXPERIMENT SPEICHERN</h3>
        </div>
        <p className="text-xs text-muted mb-3">
          Messdaten, Frage und KI-Antwort werden gespeichert. Du erhältst einen öffentlichen Link zum Teilen (z. B. für den Physikunterricht).
        </p>
        <input
          data-testid="experiment-title-input"
          value={dialog.title}
          onChange={(e) => onChangeTitle(e.target.value)}
          placeholder="Titel des Experiments"
          maxLength={120}
          className="w-full bg-surface border border-white/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-volt/60 mb-4"
        />
        <div className="flex gap-2">
          <button
            data-testid="save-experiment-cancel-btn"
            onClick={onCancel}
            className="flex-1 bg-elevated border border-white/10 rounded-xl py-3 font-semibold text-sm"
          >
            Abbrechen
          </button>
          <button
            data-testid="save-experiment-confirm-btn"
            onClick={onConfirm}
            disabled={saving}
            className="flex-1 bg-volt hover:bg-volthover disabled:opacity-50 rounded-xl py-3 font-bold text-sm flex items-center justify-center gap-2"
          >
            {saving && <CircleNotch size={14} className="animate-spin" />}
            Speichern & Link erstellen
          </button>
        </div>
      </div>
    </div>
  );
}
